import React from 'react';
import { Button } from '@mui/material';

/**
 * A customizable power button component.
 *
 * @param {string} text - The text to display on the button.
 * @param {string} [variant='outlined'] - The variant of the button. Can be 'outlined', 'contained', or 'text'.
 * @param {string} [color='primary'] - The color of the button. Can be 'primary', 'secondary', 'error', 'warning', 'info', or 'success'.
 * @param {function} onClick - The function to call when the button is clicked.
 *
 *
 * @returns {React.ReactElement} A React element representing the power button.
 */
const PowerButton = ({ text, variant = 'outlined', color = 'primary', onClick }) => {
  return (
    <Button
      size="small"
      variant={variant}
      color={color}
      onClick={onClick}
      sx={{
        color: '#363636',
        width: '350px',
        height: '40px',
        padding: '12px 24px',
        textTransform: 'none', 
        fontSize: 'clamp(14px, 2vw, 18px)',  
        display: 'flex',
        justifyContent: 'center', 
        alignItems: 'center',
        whiteSpace: 'nowrap',  
        overflow: 'hidden',  
        textOverflow: 'ellipsis',  
      }}
    >
      {text}
    </Button>
  );
};

export default PowerButton;